<template>
    <div>
        <Cell is-link center="center" to="/mime/update">
            <div slot="icon">
                 <img :src="downloadImg+user.avatar" style="width:60px "/>
            </div>
            <div slot style="padding-left: 20px">
                <p>欢迎您，{{ user.realName }}</p>
            </div>
        </Cell>
        <Cell  is-link center="center" to="/mime/password" style="height: 40px">
            <div slot style="padding-left: 20px" >
                <p>修改密码</p>
            </div>
        </Cell>
            <Button type="info" block style="width: 95%; margin: 10px auto" @click="unbind">解除绑定</Button>
                  <div style="text-align: center;font-size: 12px"><p>程序版本：<span>{{clientVersion}}</span></p></div>
    </div>
</template>

<script>
    import {Cell ,Button} from "vant";
    import { mapGetters } from 'vuex';
    import {downloadImg} from "@/config"
    import {clientVersion} from "@/config"
    export default {
        components:{Cell ,Button},
        props:{},
        data(){
            return{
                downloadImg,
                clientVersion
            }
        },
        computed:{
            ...mapGetters({user:'global/userInfo'})
        },
        created(){},
        mounted(){},
        methods:{
            unbind() {
                this.$toast.loading("正在处理中...");
                this.$http.wechat.unbind({})
                    .then(ret=>{
                        if (ret){
                            this.$toast.clear();
                            this.$toast.success("解绑成功");
                            setTimeout(() => {
                                this.$router.push("/account/bind");
                            }, 1000);
                        }
                    })
            }
        },
        watch:{}
    }
</script>

<style scoped>

</style>